import React, {useState} from 'react'
import clsx from 'clsx';
import {connect} from 'react-redux'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {makeStyles} from "@material-ui/core";
import DescriptionIcon from '@material-ui/icons/Description';
import FolderIcon from "@material-ui/icons/Folder";
import TypographyWithIcon from "components/TypographyWithIcon";
import VS from "constants/ValidationShema";
import TextInput from "components/TextInput";
import PropTypes from 'prop-types'
import Typography from "components/Typography";
import getObjectValue from "libs/getObjectValue";
import MultiButton, {createButton} from "./components/MultiButton";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    disabledEmpty: {
        fontStyle: 'italic'
    },
    disabled: {
        '& textarea': {
            color: theme.palette.text.primary
        }
    },
    textField: {
        wordBreak: "break-word",
        whiteSpace: 'pre-line',
        marginBottom: theme.spacing(2)
    }
}));

export const createEditDescriptionFile = (demandId, identity, name, description, disabled, required = false, isFolder = false) => ({demandId, identity, name, description, disabled, required, isFolder});

function EditDescriptionPopup(
    {
        editDescriptionFile,
        onClose,
        onUpdated,
        service,
        formSubmit,
    }) {

    const {demandId, identity, name, description, disabled, required, isFolder} = editDescriptionFile;
    const classes = useStyle();
    const formId = useId();
    const [working, setWorking] = useState(false);

    const handleSubmit = () => formSubmit[formId]();

    const onSubmit = ({description}) => {
        setWorking(true);
        service.updateDescription(demandId, identity, description).then(onUpdated).finally(()=> setWorking(false))
    }

    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr(disabled ? 'close': 'cancel'), onClose, disabled ? undefined :'outlined', false));
        if(!disabled)
            buttons.push(createButton(Tr('confirm'), handleSubmit, undefined, working, undefined, working));


        return <MultiButton buttons={buttons}/>;
    }

    return (
        <Dialog
            title={Tr(isFolder ? 'change_folder_description' : (disabled ? 'description' : 'change_file_description'))}
            open={true}
            maxWidth={'sm'}
            dialogActions={getActions()}
        >

            <Form
                initialValues={{
                    description: description || !disabled ? description : Tr('no_description'),
                }}
                validationSchema={Yup.object().shape({
                    description: required ? VS.string() : VS.stringNoRq(),
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>

                        <TypographyWithIcon Icon={isFolder ? FolderIcon : DescriptionIcon} className={classes.margin}>
                            {name}
                        </TypographyWithIcon>

                        {
                            disabled ?
                                <Typography className={clsx(classes.textField, {[classes.disabledEmpty]: (!description && disabled)})}>
                                    {getObjectValue('description', formikProps.values, null)}
                                </Typography>
                                :
                                <TextInput
                                    id='description'
                                    formikProps={formikProps}
                                    label={Tr('description')}
                                    multiline
                                    disabled={disabled}
                                />
                        }


                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

EditDescriptionPopup.propTypes = {
    editDescriptionFile: PropTypes.shape({
        demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        identity: PropTypes.oneOfType([PropTypes.number, PropTypes.object]).isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        disabled: PropTypes.bool.isRequired,
        required: PropTypes.bool.isRequired
    }).isRequired,
    onClose: PropTypes.func.isRequired,
    onUpdated: PropTypes.func.isRequired,
    service: PropTypes.shape({
        updateDescription: PropTypes.func.isRequired
    })
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(EditDescriptionPopup);